import {
  Skeleton as SkeletonComponent,
  Button,
  Circle,
  Paragraph,
} from "./Skeleton"

interface SkeletonComposition {
  Button: typeof Button
  Circle: typeof Circle
  Paragraph: typeof Paragraph
}

const Skeleton: typeof SkeletonComponent & SkeletonComposition = Object.assign(
  SkeletonComponent,
  {
    Button: Object.assign(Button, { displayName: "Skeleton.Button" }),
    Circle: Object.assign(Circle, { displayName: "Skeleton.Circle" }),
    Paragraph: Object.assign(Paragraph, { displayName: "Skeleton.Paragraph" }),
  },
)

export { Skeleton }
